// extracted by mini-css-extract-plugin
module.exports = {"tag-edit-tooltip":"tag-edit-tooltip___1JZSH","diagnosis-line":"diagnosis-line___x8WJx","name":"name___27qWC","del-tag-icon":"del-tag-icon___pVt3J"};